'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _components = require('../../components');

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./Home.css');

var Home = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    signupsubmit: state.signupsubmit.result
  };
}, searchActions), _dec2 = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    (0, _classCallCheck3.default)(this, Home);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this));

    _this.clickCloseModal = function () {
      _this.props.signupsubmitChange(true);
    };

    _this.renderSignupToaster = function () {
      return _react2.default.createElement(
        'div',
        { styleName: 'signup-toaster-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'signup-toaster-container' },
          _react2.default.createElement(
            'div',
            { styleName: 'signup-toaster-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'signup-toaster' },
              _react2.default.createElement(
                'div',
                { styleName: 'signup-toaster-tagline' },
                'Get updates on the climate risk of your funds'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'signup-toaster-inner-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'signup-toaster-form-wrap' },
                  _react2.default.createElement(
                    'form',
                    { styleName: 'signup-toaster-form',
                      acceptCharset: 'UTF-8',
                      method: 'post',
                      action: 'https://go.pardot.com/l/344561/2017-05-15/4zx',
                      target: 'signup_confirmation' },
                    _react2.default.createElement('input', { styleName: 'signup-toaster-input',
                      name: '344561_1307pi_344561_1307',
                      type: 'email',
                      placeholder: 'Get email updates',
                      size: '25',
                      required: true
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'signup-toaster-button-group' },
                      _react2.default.createElement('input', { styleName: 'signup-toaster-submit',
                        type: 'submit',
                        value: 'Stay in touch'
                      }),
                      _react2.default.createElement(
                        'div',
                        { style: {
                            position: 'absolute',
                            left: '-9999px',
                            top: '-9999px'
                          } },
                        _react2.default.createElement(
                          'label',
                          { htmlFor: 'pardot_extra_field' },
                          'Comments'
                        ),
                        _react2.default.createElement('input', { type: 'text', id: 'pardot_extra_field', name: 'pardot_extra_field' })
                      ),
                      _react2.default.createElement(
                        'div',
                        {
                          styleName: 'signup-toaster-no-thanks',
                          onClick: _this.clickCloseModal,
                          title: 'Close' },
                        _react2.default.createElement(
                          'div',
                          { styleName: 'signup-toaster-more' },
                          'Close ',
                          _react2.default.createElement('i', { styleName: 'signup-toaster-close', className: 'fa fa-times-circle' })
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    };

    _this.renderBanner = function () {
      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');
      return _react2.default.createElement(
        'div',
        { styleName: 'banner-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'banner-darken' },
          _react2.default.createElement(
            'div',
            { styleName: 'banner-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'banner-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'banner-title' },
                'Don\'t want your retirement savings invested in fossil fuels?'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'banner-btn-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'banner-tagline' },
                  'See mutual funds and ETFs that avoid fossil fuel investments'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.routes.clean,
                    bigbutton: true,
                    title: 'Top-rated funds'
                  },
                  _react2.default.createElement(
                    'div',
                    null,
                    'Top-rated funds',
                    _react2.default.createElement(_components.LinkIcon, null)
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'banner-tagline' },
                'Search funds from your 401(k) or IRA for fossil fuel holdings'
              ),
              _react2.default.createElement(_components.AutocompleteSearch, null),
              _react2.default.createElement(
                'div',
                { styleName: 'banner-btn-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'logo-tagline' },
                  'A project of'
                ),
                _react2.default.createElement(
                  _components.Link,
                  { to: _config2.default.links.ays, title: 'As You Sow' },
                  _react2.default.createElement('img', {
                    styleName: 'logo-ays',
                    src: aysLogo,
                    alt: 'As You Sow'
                  }),
                  _react2.default.createElement(
                    _components.SrOnly,
                    null,
                    'As You Sow'
                  )
                )
              )
            )
          )
        )
      );
    };

    _this.renderLede = function () {
      var icon = require('../../../static/images/icn-ays.png');
      // const link = config.domain
      // const message = config.shareMessage
      return _react2.default.createElement(
        'div',
        { styleName: 'x-lede' },
        _react2.default.createElement(
          'div',
          { styleName: 'x-lede-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'media-col' },
            _react2.default.createElement(
              'div',
              { styleName: 'media-icon-title-wrap' },
              _react2.default.createElement('img', {
                styleName: 'media-icon',
                alt: 'From As You Sow',
                src: icon
              }),
              _react2.default.createElement(
                'div',
                { styleName: 'media-title-wrap' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'media-title' },
                  'Introducing: Fossil Free Funds'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'media-subtitle' },
                  'From As You Sow'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'media-react-player-wrap' },
              _react2.default.createElement(_reactPlayer2.default, {
                url: 'https://vimeo.com/222906557',
                volume: 0.5
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'lede-col' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-lede-title' },
              'Fossil free investing made easy'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-lede-subtitle' },
              _react2.default.createElement(
                'strong',
                null,
                'Fossil fuel investments carry real financial risks.'
              ),
              ' Over the past years, a growing divestment movement of institutional and individual investors representing trillions in assets under management have responded to this climate risk by divesting all or some of their fossil fuel investments.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-lede-subtitle' },
              _react2.default.createElement(
                'strong',
                null,
                'Fossil Free Funds'
              ),
              ' analyzes the fossil fuel exposure and carbon footprint of thousands of U.S. mutual funds and ETFs. We make it easy to know what you own, so you can align your investments with your values.'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'x-lede-btn' },
              _react2.default.createElement(
                _components.Link,
                {
                  to: _config2.default.routes.about,
                  title: 'About | ' + _config2.default.app.title,
                  roundbutton: true
                },
                _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-info-circle' }),
                '\xA0\xA0Learn more',
                _react2.default.createElement(_components.LinkIcon, null)
              )
            )
          )
        )
      );
    };

    _this.renderPressHighlights = function () {
      var nytLogo = require('../../../static/images/nyt-logo.png');
      var lnks = [[_config2.default.links.guardianHome, 'The Guardian - The carbon bubble: why investors can no longer ' + 'ignore climate risks', require('../../../static/images/guardian-300.jpg')], [_config2.default.links.bloombergHome, 'Bloomberg BNA - GE, Microsoft Urged to Offer Fossil-Fuel-Free ' + '401(k)s', require('../../../static/images/bloomberg-300.jpg')], [_config2.default.links.fastcompanyHome, 'FastCompany - How To Convince Your Employer To Divest Your 401(k) ' + 'From Fossil Fuels', require('../../../static/images/fast-company-300.jpg')], [_config2.default.links.thinkprogressHome, 'ThinkProgress - There’s Now A Way To Find Out How Much Of Your ' + 'Retirement Is Invested In Fossil Fuels', require('../../../static/images/think-progress-300.jpg')]];

      return _react2.default.createElement(
        'div',
        { styleName: 'x-press-banner' },
        _react2.default.createElement(
          'div',
          { styleName: 'x-press' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-press-inner' },
            _react2.default.createElement(
              'blockquote',
              { styleName: 'blckqt' },
              _react2.default.createElement(
                'p',
                null,
                'If you care about climate change, your money can help shrink your carbon footprint... Now there is a tool, the website Fossil Free Funds, that helps pinpoint funds and E.T.F.s focused on companies with smaller carbon footprints.'
              ),
              _react2.default.createElement(
                'cite',
                { styleName: 'blckqtct' },
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.nytHome,
                    title: 'New York Times - Funds That Can Put Your Investments' + ' on a Low-Carbon Diet'
                  },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'blckqtct-flx' },
                    _react2.default.createElement(
                      'div',
                      null,
                      'Funds That Can Put Your Investments on a Low-Carbon Diet'
                    ),
                    _react2.default.createElement('img', {
                      styleName: 'nyt-logo',
                      src: nytLogo,
                      alt: 'New York Times - Funds That Can Put Your Investments on a Low-Carbon Diet'
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'lnk-logo-title' },
              'Read more about us in:'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'lnk-logos' },
              lnks.map(function (e, i) {
                // e = [url, title/alt, img src]
                return _react2.default.createElement(
                  _components.Link,
                  {
                    to: e[0],
                    title: e[1],
                    key: 'lnk-logo-' + i
                  },
                  _react2.default.createElement('img', {
                    styleName: 'lnk-logo',
                    src: e[2],
                    alt: e[1]
                  })
                );
              })
            )
          )
        )
      );
    };

    _this.renderTrailingContent = function () {
      var icons = [[require('../../../static/images/icn-c2-active-black.svg'), 'Top carbon reserve owners'], [require('../../../static/images/icn-co-active-black.svg'), 'Coal industry'], [require('../../../static/images/icn-og-active-black.svg'), 'Oil/gas industry'], [require('../../../static/images/icn-f5-active-black.svg'), 'Top coal-fired utilities'], [require('../../../static/images/icn-ut-active-black.svg'), 'Fossil-fired utilities']];
      return _react2.default.createElement(
        'div',
        { styleName: 'x-401k' },
        _react2.default.createElement(
          'div',
          { styleName: 'x-401k-inner' },
          _react2.default.createElement(
            'div',
            { styleName: 'x-container-title' },
            'Tracking trillions in fossil fuel investments'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-401k-info-photo' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-401k-info' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-401k-trailing-icons' },
                icons.map(function (el, idx) {
                  return _react2.default.createElement('img', {
                    key: 'fossil-icon-' + idx,
                    src: el[0],
                    alt: el[1],
                    styleName: 'x-401k-trailing-icon'
                  });
                })
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'x-401k-top' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Fossil Free Funds'
                ),
                ' is a search platform that looks at the climate impact of popular mutual funds and shows you if your money is being invested in fossil fuel companies, or companies with high carbon footprints.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Investing in coal companies, oil/gas producers, and coal-fired utilities isn\u2019t just a moral question.'
                ),
                ' Fossil fuel investments carry real financial risks. When emissions are constrained, fossil fuel companies will have their carbon assets stranded. Over the past years, a growing divestment movement of institutional and individual investors representing more than $6tn in assets under management have responded to this risk by divesting all or some of their fossil fuel investments.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Fossil Free Funds'
                ),
                ' empowers you to know exactly what you own, to see if your savings are invested in dirty energy sources, and to find investment options that support a cleaner, greener future.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Search for mutual funds and see if they\u2019re invested in fossil fuel companies.'
                ),
                ' If they are, you can use our database to find comparable options that meet your specific needs.'
              )
            )
          )
        )
      );
    };

    _this.state = {
      openModal: true
    };
    return _this;
  }

  (0, _createClass3.default)(Home, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var signupsubmit = this.props.signupsubmit ? this.props.signupsubmit : false;
      this.props.signupsubmitChange(signupsubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        this.renderBanner(),
        this.renderLede(),
        _react2.default.createElement(_components.Works, null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.Banner401k, null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.BenchmarkGrid, null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.TargetDateGrid, null),
        this.renderPressHighlights(),
        _react2.default.createElement(_components.FamilyGrid, { topN: 12 }),
        _react2.default.createElement(_components.RecentBlogPosts, null),
        this.renderTrailingContent(),
        _react2.default.createElement(_components.GetStartedInput, null)
      );
    }
  }]);
  return Home;
}(_react.Component), _class2.propTypes = {
  signupsubmit: _react.PropTypes.bool
}, _temp)) || _class) || _class);
exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1408
// module chunks = 0